import { Directive, ElementRef, Renderer2, OnInit } from '@angular/core';

@Directive({
  selector: '[nimbusSecondaryButton]',
  standalone: false,
})
export class NimbusMaterialSecondaryButtonDirective implements OnInit {
  public constructor(
    private elementRef: ElementRef,
    private renderer: Renderer2,
  ) {}

  public ngOnInit(): void {
    this.renderer.addClass(this.elementRef.nativeElement, 'nimbus-material-button');
    this.renderer.addClass(this.elementRef.nativeElement, 'secondary');
    if (!this.elementRef.nativeElement.hasAttribute('type')) {
      this.renderer.setAttribute(this.elementRef.nativeElement, 'type', 'button');
    }
  }
}
